<template>
  <div class="car-damage-marker" :class="{ readonly: readonly }">
    <v-row>
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <div>
          <h3 class="mb-0">{{ $t('bookings.damage_marking') }}</h3>
          <div class="d-flex align-center gap-2 mt-1">
            <v-chip x-small v-if="damages.length > 0" color="error" text-color="white" class="mr-1">
              {{ damages.length }} {{ $t('bookings.damage') }}
            </v-chip>
            <v-chip x-small v-if="previousDamages && previousDamages.length > 0" color="blue-grey" text-color="white" class="mr-1">
              {{ previousDamages.length }} {{ $t('bookings.previous_damages') }}
            </v-chip>
            <v-btn 
              v-if="!readonly"
              x-small 
              @click="clearAllDamages" 
              :disabled="damages.length === 0"
              color="error"
              text
            >
              {{ $t('custom.clear_all') }}
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col cols="12">
        <div class="car-map-container" ref="carMapContainer">
          <svg 
            ref="carSvg"
            width="100%" 
            :height="svgHeight" 
            viewBox="0 0 1041 1617" 
            xmlns="http://www.w3.org/2000/svg"
            @click="handleSvgClick"
            preserveAspectRatio="xMidYMid meet"
            :style="{
              '--svg-stroke': svgColors.stroke,
              '--svg-glass': svgColors.glass,
              '--svg-headlight': svgColors.headlight,
              '--svg-wheel': svgColors.wheel,
              '--svg-wheel-center': svgColors.wheelCenter,
              '--svg-indicator': svgColors.indicator,
              '--svg-reflector': svgColors.reflector,
              '--svg-detail': svgColors.detail
            }"
          >
            <!-- SVG диаграмма автомобиля -->
            <g class="car-outline">
              <g class="el-11">
                <path d="m525 1615c-5.633 0-5.633-8.45 0-8.45s5.633 8.45 0 8.45zm1-48v40.8m-157-56.54v-1.42c0-4.288-2.801-7.74-6.28-7.74h-22.64c-3.479 0-6.28 3.452-6.28 7.74v1.42c0 4.288 2.801 7.74 6.28 7.74h22.64c3.479 0 6.28-3.452 6.28-7.74zm337 0v-1.42c0-4.288-2.801-7.74-6.28-7.74h-22.64c-3.479 0-6.28 3.452-6.28 7.74v1.42c0 4.288 2.801 7.74 6.28 7.74h22.64c3.479 0 6.28-3.452 6.28-7.74zm24-20.26s1.41 35.2-21.1 35.2h-372c-22.5 0-25.3-36.6-25.3-36.6m418.4-31.6s12.7 4.2 12.7 18.3c0 14-8.45 14-8.45 14h-424s-9.9-1.4-9.9-14c0-12.7 9.9-18.3 9.9-18.3m337.8-14h-256m1-31h53.5m150.5 0h53.5m-55.5-7v14.1h-148v-14.1zm52.8 51.6h-255.8v-67.6h255.8" fill="none" stroke="#000" stroke-width="5"/>
              </g>
              <g fill="none" stroke="#000">
                <g class="el-1" transform="rotate(90 563 538)">
                  <path d="m586 394h-294l-14.1 103-7.04 11.3v142l7.04 14.1 15.5 101h289" stroke-width="5"/>
                  <path d="m303 574-11.7 16.1-19-6.16v-19.9l19-6.16z" stroke-width="5"/>
                  <g stroke-width="2">
                    <path d="m272 507 315-111"/>
                    <path d="m271 650 315 115"/>
                    <path d="m582 394s-42.2 78.8-42.2 111v146c0 40.8 42.2 114 42.2 114"/>
                  </g>
                </g>
                <g stroke-width="5">
                  <path class="el-12" d="m166 543c-22.5 0-92.6 3.95-107 22.2v-40.7s104-5.72 106-97.2c1.43-91.4-106-98.6-106-98.6v-65.7l38.6-18.6c0-0.52 0-26.2 17.1-21.4 16.6 4.65 41.4-4.29 41.4 17.1s-1.43 47.1-1.43 47.1l44.3 15.7 2.86-41.4s24.3 34.3 32.8 119c7.68 75.5 8.48 142 25 180-31-14.1-71.6-17.7-94.1-17.7z"/>
                  <path class="el-18" d="m876 543c22.5 0 92.6 3.95 107 22.2v-40.7s-104-5.72-106-97.2c-1.43-91.4 106-98.6 106-98.6v-65.7l-38.6-18.6c0-0.52 0-26.2-17.1-21.4-16.6 4.65-41.4-4.29-41.4 17.1s1.43 47.1 1.43 47.1l-44.3 15.7-2.86-41.4s-24.3 34.3-32.8 119c-7.68 75.5-8.48 142-25 180 31-14.1 71.6-17.7 94.1-17.7z"/>
                  <path class="el-17" d="m59 1024s103 12.8 106 95.7c2.86 82.8-106 98.5-106 98.5s1.5 74.3 0 98.6c-1.4 24.3 12.9 22.9 27.2 27.2 14.3 4.2 2.8 10 12.8 18.5 10 8.6 27.1 7.2 41.4 2.9s15.6-41.5 15.6-41.5l52.9 5.8-4.29 30s20 12.8 32.9-25.7c12.9-38.6 12.9-57.2 20-80 5.2-16.7 55.9-110 72.9-152 9.44-22.8 17.2-66 22-109-12.7 18.3-51.7 57.6-105 94.2s-59.1 8.4-74.6-18.3c-15.5-26.8-43.3-49.2-114-67.5z"/>
                  <path class="el-23" d="m983 1024s-103 12.8-106 95.7c-2.86 82.8 106 98.5 106 98.5s-1.5 74.3 0 98.6c1.4 24.3-12.9 22.9-27.2 27.2-14.3 4.2-2.8 10-12.8 18.5-10 8.6-27.1 7.2-41.4 2.9s-15.6-41.5-15.6-41.5l-52.9 5.8 4.29 30s-20 12.8-32.9-25.7c-12.9-38.6-12.9-57.2-20-80-5.2-16.7-55.9-110-72.9-152-9.44-22.8-17.2-66-22-109 12.7 18.3 51.7 57.6 105 94.2s59.1 8.4 74.6-18.3c15.5-26.8 43.3-49.2 114-67.5z"/>
                  <path class="el-21" d="m983 1e3c-70.3 18.3-98.2 40.7-114 67.5-15.5 26.7-21.1 54.9-74.6 18.3s-92.5-75.9-105-94.2c-3.81-34.4-5.82-69.2-5.18-91.9 0.389-14 0.355-34.5 0.415-53.4 5.63-1.4 80.6-3.85 106-6.32 18.7-3.67 51.2-4.98 87.3-6.15 22.5 0 79.9 6.96 105 12.6v154"/>
                  <path class="el-33" d="m775 573c-22.9 35.7-78.6 137-78.6 137-11.1 29.4-12.2 88.3-12.4 138 5.63-1.4 80.6-3.84 106-6.31 18.7-3.67 51.2-4.98 87.3-6.15 22.5 0 80.2 7.03 106 12.7l-0.277-283c-14-18.3-84.1-22.5-107-22.5s-63.3 4.22-94.2 18c-1.81 4.22-3.95 8.35-6.34 12.1z"/>
                  <path class="el-15" d="m59 1e3c70.3 18.3 98.2 40.7 114 67.5 15.5 26.7 21.1 54.9 74.6 18.3s92.5-75.9 105-94.2c3.81-34.4 5.82-69.2 5.18-91.9-0.389-14-0.355-34.5-0.415-53.4-5.63-1.4-80.6-3.85-106-6.32-18.7-3.67-51.2-4.98-87.3-6.15-22.5 0-79.9 6.96-105 12.6v154"/>
                  <path class="el-34" d="m266 573c22.9 35.7 78.6 137 78.6 137 11.1 29.4 12.2 88.3 12.4 138-5.63-1.4-80.6-3.84-106-6.31-18.7-3.67-51.2-4.98-87.3-6.15-22.5 0-80.2 7.03-106 12.7l1.3-283c14-18.3 83.08-22.46 106-22.46s63.3 4.22 94.2 18c1.81 4.22 3.95 8.35 6.34 12.1z"/>
                </g>
              </g>
              <g class="el-14" transform="rotate(90,563,538)" stroke="#000">
                <path class="el-6 el-25" d="m582 394 141 38s-8.44 49.2-8.44 72v148c0 31 8.44 78.8 8.44 78.8l-141 33.8s-17.2-61.9-17.2-92.9c0.38-33.8 1.76-155 2.11-186-1.41-31 15.1-91.5 15.1-91.5z" fill="#f0ffeb" stroke-width="5"/>
                <path d="m565 506 32.4-32.4v-40.8 113" fill="none" stroke-width="2"/>
                <path d="m564 627 32.4-32.4v-40.8 113" fill="none" stroke-width="2"/>
              </g>
              <g class="el-20" transform="rotate(90,563,538)" stroke="#000">
                <path d="m1073 432s-12.7 47.9-12.7 73.2v146c0 25.3 12.7 77.4 12.7 77.4l206 38h108s14-81.6 14-115v-148c0-38-14-110-14-110h-108z" fill="none" stroke-width="5"/>
                <path class="el-26" d="m1084 451s-8.4 40.8-8.4 56.3v145c0 19.7 7 57.7 7 57.7s94.3 26.7 124 26.7h42.2v-312h-47.8c-25.4 0-117 26.8-117 26.8z" fill="#f0ffeb" stroke-width="5"/>
                <path d="m1278 394s30.9 40.8 30.9 111v146c0 64.8-30.9 117-30.9 117" fill="none" stroke-width="2"/>
                <path d="m1245 549-32.4-32.4v-40.8 113" fill="none" stroke-width="2"/>
              </g>
              <g class="el-5" transform="rotate(90,563,538)" fill="none" stroke="#000">
                <path d="m147 487 1.41-91.5s5.63-23.9-25.3-25.3c-31-1.41-26.8 2.81-26.8 2.81l1.41 415h28.2c28.2 0 22.5-22.5 22.5-22.5v-95.7c-12.7 0-11.3-9.61-11.3-16.9v-149c0.45-18.9 9.86-16.9 9.86-16.9z" stroke-width="5"/>
                <path d="m97.3 451h49.3" stroke-width="2.2"/>
                <path d="m100 711h49.3" stroke-width="2.2"/>
                <g stroke-width="2">
                  <path d="m107 450v260"/>
                  <path d="m117 451v260"/>
                  <path d="m127 451v260"/>
                </g>
              </g>
              <path class="el-4" d="m363 74.9h26v45h-52v-45z" fill="#ffffc0" stroke-width="0"/>
              <path class="el-3" d="m679 74.9h27.4v45h-54.9v-45z" fill="#ffffc0" stroke-width="0"/>
              <g class="el-24" fill="none" stroke="#000">
                <path d="m731 71.5s12.7-4.23 12.7-18.3c0-14.1-8.45-14.1-8.45-14.1h-424s-9.9 1.41-9.9 14.1c0 12.7 9.9 18.3 9.9 18.3" stroke-width="5"/>
                <path d="m731 37.8s1.41-35.2-21.1-35.2h-372c-22.5 0-25.3 36.6-25.3 36.6" stroke-width="5"/>
                <rect transform="rotate(90)" x="12.5" y="-707" width="16.9" height="35.2" rx="7.74" ry="6.28" stroke-width="2"/>
                <rect transform="rotate(90)" x="12.5" y="-369" width="16.9" height="35.2" rx="7.74" ry="6.28" stroke-width="2"/>
              </g>
              <rect class="el-2" transform="rotate(90)" x="166" y="-710" width="31" height="377" fill="none" stroke="#000" stroke-width="2"/>
              <g class="el-10" transform="rotate(90,563,538)" fill="none" stroke="#000">
                <path d="m1455 380v73.2h67.6v-83l-25.3-14.1z" stroke-width="5"/>
                <path d="m1454 379 67.5 74.6" stroke-width="2"/>
                <path d="m1454 454 67.5-73.2" stroke-width="2"/>
              </g>
              <g class="el-9" transform="rotate(90,563,538)" fill="none" stroke="#000">
                <path d="m1455 709h67.6v78.9l-23.9 14-43.7-18.3z" stroke-width="5"/>
                <path d="m1454 709 67.6 74.6" stroke-width="2"/>
                <path d="m1454 784 67.6-73.2" stroke-width="2"/>
              </g>
              <g class="el-7" transform="rotate(90,543,518)" fill="none" stroke="#000">
                <path d="m714 612v-148c0-22.7 8.44-72 8.44-72s94.3 5.63 152 5.63c107 0 201-5.63 201-5.63s-13.4 47.9-13.4 73.2v146c0 25.3 12.7 77.4 12.7 77.4s-77.4-5.63-200-5.63c-69 0-152 7.04-152 7.04s-8.44-47.9-8.44-78.8z" stroke-width="5"/>
                <rect x="769" y="451" width="107" height="182" rx="31.2" ry="34.4" stroke-width="2"/>
                <path d="m1032 551-38.7-38.7" stroke-width="2"/>
              </g>
              <g stroke="#000" stroke-width="2">
                <g transform="rotate(90,562,777)" fill="#3c3c3c">
                  <path transform="translate(-79.5,450)" d="m-77.4 189c0 2.33-1.89 4.22-4.22 4.22s-4.22-1.89-4.22-4.22 1.89-4.22 4.22-4.22 4.22 1.89 4.22 4.22z"/>
                  <path transform="translate(-79.5,570)" d="m-77.4 189c0 2.33-1.89 4.22-4.22 4.22s-4.22-1.89-4.22-4.22 1.89-4.22 4.22-4.22 4.22 1.89 4.22 4.22z"/>
                  <path transform="translate(-79.5,690)" d="m-77.4 189c0 2.33-1.89 4.22-4.22 4.22s-4.22-1.89-4.22-4.22 1.89-4.22 4.22-4.22 4.22 1.89 4.22 4.22z"/>
                  <path transform="translate(-79.5,810)" d="m-77.4 189c0 2.33-1.89 4.22-4.22 4.22s-4.22-1.89-4.22-4.22 1.89-4.22 4.22-4.22 4.22 1.89 4.22 4.22z"/>
                </g>
                <g transform="rotate(90,561,776)">
                  <path transform="translate(1382,448)" d="m-77.4 189c0 2.33-1.89 4.22-4.22 4.22s-4.22-1.89-4.22-4.22 1.89-4.22 4.22-4.22 4.22 1.89 4.22 4.22z"/>
                  <path transform="translate(1382,568)" d="m-77.4 189c0 2.33-1.89 4.22-4.22 4.22s-4.22-1.89-4.22-4.22 1.89-4.22 4.22-4.22 4.22 1.89 4.22 4.22z"/>
                  <path transform="translate(1382,688)" d="m-77.4 189c0 2.33-1.89 4.22-4.22 4.22s-4.22-1.89-4.22-4.22 1.89-4.22 4.22-4.22 4.22 1.89 4.22 4.22z"/>
                  <path transform="translate(1382,809)" d="m-77.4 189c0 2.33-1.89 4.22-4.22 4.22s-4.22-1.89-4.22-4.22 1.89-4.22 4.22-4.22 4.22 1.89 4.22 4.22z"/>
                </g>
                <g transform="rotate(90,563,538)" fill="none">
                  <path d="m269 1003h92.8"/>
                  <path d="m542 1e3h517"/>
                  <path d="m1232 1006h151"/>
                </g>
              </g>
              <g transform="rotate(90,563,538)" stroke="#000">
                <path class="el-27" d="m605 851c15.7-18.6 123-81.5 151-88.6 29.5-7.41 103-7.14 103-7.14l-7.14 95.7z" fill="#f0ffeb" stroke-width="5"/>
                <path d="m645 821v28.6" fill="none" stroke-width="2"/>
                <path class="el-8" d="m885 756-4.29 94.3h207c-11.3-20.8-46.6-74.9-72.9-88.6-14.3-10-82.9-4.33-130-5.75z" fill="#f0ffeb" stroke-width="5"/>
                <path class="el-38" d="m1052 764s80 84.3 85.7 87.1c5.7 2.86 116 1.43 116 1.43s-77.1-47.1-103-58.6-90-31.4-98.6-30z" fill="#f0ffeb" stroke-width="5"/>
              </g>
              
              <!-- ВРЕМЕННЫЕ ПОДПИСИ ДЛЯ ОТЛАДКИ - показываем el-классы НА РЕАЛЬНЫХ ПОЗИЦИЯХ -->
              <g v-if="false" style="pointer-events: none;">
                <!-- Передняя часть (сверху) -->
                <text x="100" y="80" font-size="20" fill="yellow" font-weight="bold">el-4 (фара)</text>
                <text x="120" y="240" font-size="20" fill="red" font-weight="bold">el-5 (бампер)</text>
                <text x="363" y="95" font-size="18" fill="lime" font-weight="bold">el-4</text>
                <text x="679" y="95" font-size="18" fill="lime" font-weight="bold">el-3</text>
                <text x="520" y="50" font-size="20" fill="cyan" font-weight="bold" text-anchor="middle">el-24 (решетка)</text>
                <text x="710" y="190" font-size="20" fill="magenta" font-weight="bold">el-2 (лобовое)</text>
                <text x="520" y="270" font-size="18" fill="orange" font-weight="bold" text-anchor="middle">el-29</text>
                
                <!-- Левая сторона -->
                <text x="166" y="340" font-size="18" fill="lime" font-weight="bold">el-12 (крыло)</text>
                <text x="80" y="490" font-size="18" fill="lime" font-weight="bold">el-13 (колесо)</text>
                <text x="150" y="560" font-size="18" fill="magenta" font-weight="bold">el-14 (дверь)</text>
                <text x="270" y="640" font-size="16" fill="cyan" font-weight="bold">el-6</text>
                <text x="40" y="760" font-size="16" fill="white" font-weight="bold">el-10</text>
                <text x="150" y="920" font-size="18" fill="magenta" font-weight="bold">el-17 (дверь)</text>
                <text x="270" y="1000" font-size="16" fill="cyan" font-weight="bold">el-27</text>
                <text x="80" y="1090" font-size="18" fill="lime" font-weight="bold">el-16 (колесо)</text>
                <text x="59" y="1240" font-size="18" fill="lime" font-weight="bold">el-15 (крыло)</text>
                
                <!-- Правая сторона -->
                <text x="876" y="340" font-size="18" fill="lime" font-weight="bold">el-18 (крыло)</text>
                <text x="920" y="490" font-size="18" fill="lime" font-weight="bold">el-19 (колесо)</text>
                <text x="820" y="560" font-size="18" fill="magenta" font-weight="bold">el-20 (дверь)</text>
                <text x="730" y="640" font-size="16" fill="cyan" font-weight="bold">el-26</text>
                <text x="980" y="760" font-size="16" fill="white" font-weight="bold">el-9</text>
                <text x="820" y="920" font-size="18" fill="magenta" font-weight="bold">el-23 (дверь)</text>
                <text x="730" y="1000" font-size="16" fill="cyan" font-weight="bold">el-28</text>
                <text x="920" y="1090" font-size="18" fill="lime" font-weight="bold">el-22 (колесо)</text>
                <text x="900" y="1240" font-size="18" fill="lime" font-weight="bold">el-21 (крыло)</text>
                
                <!-- Центр -->
                <text x="520" y="730" font-size="20" fill="orange" font-weight="bold" text-anchor="middle">el-7 (крыша)</text>
                
                <!-- Задняя часть (снизу) -->
                <text x="520" y="1360" font-size="18" fill="magenta" font-weight="bold" text-anchor="middle">el-8 (стекло)</text>
                <text x="520" y="1480" font-size="20" fill="cyan" font-weight="bold" text-anchor="middle">el-11 (бампер)</text>
                <text x="520" y="1590" font-size="20" fill="red" font-weight="bold" text-anchor="middle">el-1 (багажник)</text>
                <text x="250" y="1510" font-size="18" fill="white" font-weight="bold">el-31</text>
                <text x="750" y="1510" font-size="18" fill="white" font-weight="bold">el-32</text>
                <text x="520" y="1540" font-size="18" fill="orange" font-weight="bold" text-anchor="middle">el-30</text>
              </g>
              <g transform="rotate(90,563,538)" fill="none" stroke="#000">
                <g stroke-width="2">
                  <path d="m344 1002s15.5-87.9 107-87.9 110 86.38 110 86.38"/>
                  <path d="m1041 1e3s15.5-85.8 107-85.8 110 91.2 110 91.2"/>
                  <path d="m306.2 947.7 63.41 1.788"/>
                </g>
                <path d="m1019 750c18.3 12.7 56.3 50.7 92.9 104s8.4 59.1-18.3 74.6c-26.8 15.5-49.3 42.2-67.6 113" stroke-width="5"/>
                <g stroke-width="2">
                  <path d="m1353 946h-126"/>
                  <path d="m529.7 945h542.3"/>
                  <path d="m1049 795v54.9"/>
                </g>
              </g>
              <g stroke="#000" stroke-width="2">
                <g transform="rotate(90,563,538)">
                  <rect class="el-31" x="799" y="894" width="41.3" height="14.5" rx="2.93" ry="7.38" fill="#e6e6e6"/>
                  <rect class="el-39" x="1056" y="894" width="41.3" height="14.5" rx="2.93" ry="7.38" fill="#e6e6e6"/>
                  <rect class="el-30" x="500" y="896" width="18.8" height="11.7" rx="1.63" ry="7.69" fill="#ffcb00"/>
                </g>
                <g class="el-13" transform="rotate(90,563,538)">
                  <path d="m528 1024a76 76 0 1 1-152 0 76 76 0 1 1 152 0z" fill="#c8c8c8"/>
                  <path d="m496 1024a44.4 44.4 0 1 1-88.7 0 44.4 44.4 0 1 1 88.7 0z" fill="#fff"/>
                </g>
                <g class="el-16" transform="rotate(90,563,538)">
                  <path d="m1223 1024a76 76 0 1 1-152 0 76 76 0 1 1 152 0z" fill="#c8c8c8"/>
                  <path d="m1191 1024a44.4 44.4 0 1 1-88.7 0 44.4 44.4 0 1 1 88.7 0z" fill="#fff"/>
                </g>
                <g transform="rotate(90,563,538)" fill="none">
                  <path d="m269 158.1h92.8"/>
                  <path d="m542 157h517"/>
                  <path d="m1232 157h151"/>
                </g>
              </g>
              <g transform="rotate(90,563,538)" stroke="#000">
                <path class="el-35" d="m605 310c15.7 18.6 123 81.5 151 88.6 29.5 7.41 103 7.14 103 7.14l-7.14-95.7z" fill="#f0ffeb" stroke-width="5"/>
                <path class="el-35" d="m645 340v-28.6" fill="none" stroke-width="2"/>
                <path class="el-36" d="m885 404-4.29-94.3h207c-11.3 20.8-46.6 74.9-72.9 88.6-14.3 10-82.9 4.33-130 5.75z" fill="#f0ffeb" stroke-width="5"/>
                <path class="el-37" d="m1052 397s80-84.3 85.7-87.1c5.7-2.86 116-1.43 116-1.43s-77.1 47.1-103 58.6-90 31.4-98.6 30z" fill="#f0ffeb" stroke-width="5"/>
              </g>
              <g transform="rotate(90,563,538)" fill="none" stroke="#000">
                <g stroke-width="2">
                  <path d="m344 159s15.5 85.9 107 85.9 110-87.3 110-87.3"/>
                  <path d="m1041 158s15.5 85.8 107 85.8 110-87.2 110-87.2"/>
                  <path d="m308 212.2h63.3"/>
                </g>
                <path d="m1019 411c18.3-12.7 56.3-50.7 92.9-104s8.4-59.1-18.3-74.6c-26.8-15.5-49.3-42.2-67.6-113" stroke-width="5"/>
                <g stroke-width="2">
                  <path d="m1357 213h-130"/>
                  <path d="m527 215h545"/>
                  <path d="m1049 366v-54.9"/>
                </g>
              </g>
              <g stroke="#000" stroke-width="2">
                <g transform="rotate(90,563,538)">
                  <rect class="el-32" transform="scale(1,-1)" x="799" y="-266" width="41.3" height="14.5" rx="2.93" ry="7.38" fill="#e6e6e6"/>
                  <rect class="el-40" transform="scale(1,-1)" x="1056" y="-266" width="41.3" height="14.5" rx="2.93" ry="7.38" fill="#e6e6e6"/>
                  <rect class="el-29" transform="scale(1,-1)" x="500" y="-265" width="18.8" height="11.7" rx="1.63" ry="7.69" fill="#ffcb00"/>
                </g>
                <g class="el-19" transform="matrix(0,1,1,0,-60,-25.1)">
                  <path d="m528 1024a76 76 0 1 1-152 0 76 76 0 1 1 152 0z" fill="#c8c8c8"/>
                  <path d="m496 1024a44.4 44.4 0 1 1-88.7 0 44.4 44.4 0 1 1 88.7 0z" fill="#fff"/>
                </g>
                <g class="el-22" transform="rotate(90,563,538)">
                  <path d="m1223 137a76 76 0 1 0-152 0 76 76 0 1 0 152 0z" fill="#c8c8c8"/>
                  <path d="m1191 137a44.4 44.4 0 1 0-88.7 0 44.4 44.4 0 1 0 88.7 0z" fill="#fff"/>
                </g>
              </g>
              <path d="m709 72.9v49.3" fill="none" stroke="#000" stroke-width="2.2"/>
              <path d="m335 73.8v49.3" fill="none" stroke="#000" stroke-width="2.2"/>
            </g>
            
            <!-- Маркеры повреждений - должны быть последними для правильного отображения -->
            <g class="damage-markers">
              <!-- Предыдущие повреждения (от выдачи при приеме) -->
              <g 
                v-for="(damage, index) in (previousDamages || [])" 
                :key="`prev-damage-${damage.id || index}-${damage.x}-${damage.y}`"
                :transform="`translate(${Number(damage.x) || 0}, ${Number(damage.y) || 0})`"
                class="previous-damage-marker-group"
                style="pointer-events: none; cursor: default;"
              >
                <!-- Маркер предыдущего повреждения с цветом типа повреждения -->
                <circle 
                  cx="0" 
                  cy="0" 
                  r="15" 
                  :fill="getDamageTypeColorHex(damage.damage_type)" 
                  stroke="#ffffff" 
                  stroke-width="4"
                  opacity="0.7"
                  class="previous-damage-point"
                />
                <!-- Номер предыдущего повреждения -->
                <text 
                  x="0" 
                  y="-20" 
                  text-anchor="middle" 
                  :fill="getDamageTypeColorHex(damage.damage_type)" 
                  font-size="18" 
                  font-weight="bold"
                  opacity="0.8"
                  class="previous-damage-number"
                  style="pointer-events: none; user-select: none; text-shadow: 2px 2px 4px rgba(255,255,255,0.9);"
                >
                  {{ index + 1 }}
                </text>
                <!-- Иконка внутри маркера (для обозначения, что это старое повреждение) -->
                <text 
                  x="0" 
                  y="6" 
                  text-anchor="middle" 
                  fill="#ffffff" 
                  font-size="14" 
                  font-weight="bold"
                  style="pointer-events: none; user-select: none;"
                >
                  ✓
                </text>
              </g>
              
              <!-- Текущие повреждения -->
              <g 
                v-for="(damage, index) in (damages || [])" 
                :key="`damage-${damage.id || index}-${damage.x}-${damage.y}`"
                :transform="`translate(${Number(damage.x) || 0}, ${Number(damage.y) || 0})`"
                @click.stop="editDamage(damage)"
                class="damage-marker-group"
                :style="readonly ? 'pointer-events: none; cursor: default;' : 'pointer-events: all; cursor: pointer;'"
              >
                <!-- Подсветка маркера (пульсирующее кольцо) -->
                <circle 
                  v-if="highlightedDamageId === damage.id"
                  cx="0" 
                  cy="0" 
                  r="25" 
                  fill="none"
                  :stroke="getDamageTypeColorHex(damage.damage_type)"
                  stroke-width="3"
                  class="damage-highlight"
                  style="pointer-events: none;"
                />
                <!-- Маркер повреждения с цветом в зависимости от типа -->
                <circle 
                  cx="0" 
                  cy="0" 
                  r="15" 
                  :fill="getDamageTypeColorHex(damage.damage_type)" 
                  stroke="#ffffff" 
                  stroke-width="4"
                  class="damage-point"
                  :class="{ 'damage-point-highlighted': highlightedDamageId === damage.id }"
                  :style="readonly ? 'pointer-events: none;' : 'pointer-events: all;'"
                />
                <!-- Номер повреждения -->
                <text 
                  x="0" 
                  y="-20" 
                  text-anchor="middle" 
                  :fill="getDamageTypeColorHex(damage.damage_type)" 
                  font-size="18" 
                  font-weight="bold"
                  class="damage-number"
                  style="pointer-events: none; user-select: none; text-shadow: 2px 2px 4px rgba(255,255,255,0.9);"
                >
                  {{ index + 1 }}
                </text>
              </g>
            </g>
          </svg>
        </div>
      </v-col>
    </v-row>
    
    <!-- Список предыдущих повреждений -->
    <v-row v-if="previousDamages && previousDamages.length > 0" class="mt-3">
      <v-col cols="12">
        <v-subheader class="px-0">
          <v-icon small left color="grey">mdi-history</v-icon>
          {{ $t('bookings.previous_damages_from_checkin') }}
        </v-subheader>
        <v-list dense>
          <v-list-item 
            v-for="(damage, index) in previousDamages" 
            :key="`prev-${damage.x}-${damage.y}-${damage.damage_type}-${index}`"
            class="damage-list-item previous-damage-item"
          >
            <v-list-item-avatar v-if="damage.photo" @click.stop="openFullscreenImage(damage.photo.url)" class="clickable-avatar">
              <v-img 
                :src="damage.photo.small_url || damage.photo.url" 
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-list-item-avatar>
            <v-list-item-avatar v-else>
              <v-icon :color="getDamageTypeColor(damage.damage_type)">mdi-alert-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('bookings.damage') }} #{{ index + 1 }}
                <span v-if="damage.carPart" class="grey--text text--darken-1 font-weight-regular">
                  - {{ getCarPartName(damage.carPart) }}
                </span>
                <v-chip 
                  x-small 
                  :color="getDamageTypeColor(damage.damage_type)"
                  class="ml-2"
                  text-color="white"
                >
                  {{ getDamageTypeLabel(damage.damage_type) }}
                </v-chip>
                <v-icon x-small color="grey" class="ml-1">mdi-check</v-icon>
              </v-list-item-title>
              <v-list-item-subtitle v-if="damage.description">
                {{ damage.description }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon x-small @click.stop="scrollToMarker(damage)" :title="$t('bookings.show_on_diagram')">
                <v-icon x-small color="grey">mdi-crosshairs-gps</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    
    <!-- Список текущих повреждений -->
    <v-row v-if="damages.length > 0" class="mt-3">
      <v-col cols="12">
        <v-subheader v-if="previousDamages && previousDamages.length > 0" class="px-0">
          <v-icon small left color="error">mdi-alert</v-icon>
          {{ mode === 'checkout' ? $t('bookings.current_damages_at_return') : $t('bookings.current_damages') }}
        </v-subheader>
        <v-list dense>
          <v-list-item 
            v-for="(damage, index) in damages" 
            :key="`${damage.x}-${damage.y}-${damage.damage_type}-${index}`"
            class="damage-list-item"
          >
            <v-list-item-avatar v-if="damage.photo" @click.stop="openFullscreenImage(damage.photo.url)" class="clickable-avatar">
              <v-img 
                :src="damage.photo.small_url || damage.photo.url" 
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-list-item-avatar>
            <v-list-item-avatar v-else>
              <v-icon :color="getDamageTypeColor(damage.damage_type)">mdi-alert-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content @click="!readonly ? editDamage(damage) : null" style="cursor: pointer;">
              <v-list-item-title>
                {{ $t('bookings.damage') }} #{{ index + 1 }}
                <span v-if="damage.carPart" class="grey--text text--darken-1 font-weight-regular">
                  - {{ getCarPartName(damage.carPart) }}
                </span>
                <v-chip 
                  x-small 
                  :color="getDamageTypeColor(damage.damage_type)"
                  class="ml-2"
                  text-color="white"
                >
                  {{ getDamageTypeLabel(damage.damage_type) }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle v-if="damage.description">
                {{ damage.description }}
              </v-list-item-subtitle>
              
              <!-- Компонент загрузки фото для конкретного повреждения -->
              <div v-if="!readonly && !damage.photo" class="mt-2" @click.stop>
                <v-btn 
                  x-small 
                  outlined 
                  color="primary"
                  @click="startPhotoUpload(damage)"
                  :disabled="uploadingDamageId !== null"
                >
                  <v-icon x-small left>mdi-camera</v-icon>
                  {{ $t('bookings.add_photo') }}
                </v-btn>
              </div>
            </v-list-item-content>
            <v-list-item-action>
              <div class="d-flex flex-column">
                <v-btn icon x-small @click.stop="scrollToMarker(damage)" :title="$t('bookings.show_on_diagram')">
                  <v-icon x-small color="primary">mdi-crosshairs-gps</v-icon>
                </v-btn>
                <v-btn v-if="!readonly" icon x-small @click.stop="removeDamage(damage.id)" :title="$t('custom.delete')">
                  <v-icon x-small>mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    
    <!-- Диалог редактирования повреждения -->
    <v-dialog v-model="showDamageDialog" max-width="650px" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon v-if="showPhotoUploadInDialog" left color="primary">mdi-camera-plus</v-icon>
          <v-icon v-else left>mdi-alert-circle</v-icon>
          {{ showPhotoUploadInDialog ? $t('bookings.add_photo') : (currentDamage.id ? $t('bookings.edit_damage') : $t('bookings.add_damage')) }}
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelEdit">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-3">
          <!-- Режим редактирования повреждения -->
          <div v-if="!showPhotoUploadInDialog">
            <!-- Фото повреждения если оно есть -->
            <div v-if="currentDamage.photo" class="mb-3 position-relative">
              <v-img 
                :src="currentDamage.photo.url" 
                max-height="300"
                contain
                class="grey lighten-2 rounded clickable-image"
                @click="openFullscreenImage(currentDamage.photo.url)"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
            
            <!-- Название части автомобиля -->
            <v-alert
              v-if="currentDamage.carPart"
              dense
              text
              type="info"
              class="mb-3"
              icon="mdi-car-side"
            >
              <span class="font-weight-bold">{{ $t('bookings.car_part') }}:</span> {{ getCarPartName(currentDamage.carPart) }}
            </v-alert>
            
            <v-select
              v-model="currentDamage.damage_type"
              :items="damageTypes"
              :label="$t('bookings.damage_type')"
              item-text="text"
              item-value="value"
              class="mb-3"
            ></v-select>
            <v-textarea
              v-model="currentDamage.description"
              :label="$t('bookings.damage_description')"
              rows="1"
              :placeholder="$t('bookings.damage_description_placeholder')"
            ></v-textarea>
          </div>
          
          <!-- Режим загрузки фото -->
          <div v-else>
            <!-- Информация о повреждении -->
            <v-alert
              dense
              text
              type="success"
              class="mb-3"
              icon="mdi-check-circle"
            >
              {{ $t('bookings.damage_saved_add_photo') }}
            </v-alert>
            
            <!-- Компонент загрузки фото -->
            <UppyDamageImage
              v-if="uploadingDamageId && bookingId"
              :key="`photo-upload-${uploadingDamageId}`"
              :booking-id="bookingId"
              :mode="mode"
              :booking-damage-id="uploadingDamageId"
              upload-type="damage_photo"
              @upload-success="handleDamagePhotoUploadSuccessInDialog"
              @upload-error="handleDamagePhotoUploadError"
            />
            <div v-else class="text-center py-4">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
          </div>
        </v-card-text>
        <v-card-actions v-if="!showPhotoUploadInDialog">
          <v-spacer></v-spacer>
          <v-btn text @click="cancelEdit">
            {{ $t('custom.close') }}
          </v-btn>
          <v-btn color="primary" @click="saveDamage">
            {{ $t('custom.save') }}
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn text @click="skipPhotoUpload">
            {{ $t('custom.skip') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Диалог полноэкранного просмотра фото -->
    <v-dialog v-model="showFullscreenImage" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card dark class="fullscreen-image-dialog">
        <v-toolbar dark color="black">
          <v-toolbar-title>{{ $t('bookings.damage_photo') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark :href="fullscreenImageUrl" download target="_blank">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn icon dark @click="showFullscreenImage = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-0 fill-height d-flex align-center justify-center" @click="showFullscreenImage = false">
          <v-img
            v-if="fullscreenImageUrl"
            :src="fullscreenImageUrl"
            contain
            max-height="100vh"
            max-width="100vw"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="white" size="64"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
    
    <!-- Диалог загрузки фото повреждения через Uppy -->
    <v-dialog v-model="showPhotoUploadDialog" max-width="650px" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon left color="primary">mdi-camera-plus</v-icon>
          {{ $t('bookings.add_photo') }}
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelPhotoUpload">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-3 pb-4">
          <UppyDamageImage
            v-if="showPhotoUploadDialog && uploadingDamageId && bookingId"
            :key="`photo-upload-${uploadingDamageId}`"
            :booking-id="bookingId"
            :mode="mode"
            :booking-damage-id="uploadingDamageId"
            upload-type="damage_photo"
            @upload-success="handleDamagePhotoUploadSuccess"
            @upload-error="handleDamagePhotoUploadError"
          />
          <div v-else class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UppyDamageImage from '@/plugins/uppy_damage_image.vue'

export default {
  name: 'CarDamageMarker',
  components: {
    UppyDamageImage
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'checkin',
      validator: (value) => ['checkin', 'checkout'].includes(value)
    },
    bookingId: {
      type: [Number, String],
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    previousDamages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      damages: [],
      showDamageDialog: false,
      showPhotoUploadInDialog: false, // Режим загрузки фото внутри диалога повреждения
      currentDamage: {
        id: null,
        x: 0,
        y: 0,
        damage_type: 'scratch',
        description: '',
        carPart: null,
        photo: null
      },
      damageTypes: [
        { text: this.$t('bookings.damage_scratch'), value: 'scratch' },
        { text: this.$t('bookings.damage_dent'), value: 'dent' },
        { text: this.$t('bookings.damage_crack'), value: 'crack' },
        { text: this.$t('bookings.damage_break'), value: 'break' },
        { text: this.$t('bookings.damage_other'), value: 'other' }
      ],
      nextId: 1,
      svgHeight: '600px',
      updatingFromInternal: false,
      uploadFile: null,
      isUploading: false,
      uploadingDamageId: null,
      showFullscreenImage: false,
      fullscreenImageUrl: null,
      deletingPhotoId: null,
      showPhotoUploadDialog: false,
      highlightedDamageId: null
    }
  },
  computed: {
    carPartNames() {
      return {
        'el-1': this.$t('car_parts.hood'),                      // Капот
        'el-2': this.$t('car_parts.hood'),                      // Ветровик на капоте
        'el-3': this.$t('car_parts.headlight_right'),           // Правая передняя фара
        'el-4': this.$t('car_parts.headlight_left'),            // Левая передняя фара
        'el-5': this.$t('car_parts.grille'),                   // Решетка радиатора
        'el-6': this.$t('car_parts.windshield'),                // Лобовое стекло
        'el-7': this.$t('car_parts.roof'),                      // Крыша
        'el-9': this.$t('car_parts.taillight_left'),            // Задняя левая фара
        'el-10': this.$t('car_parts.taillight_right'),          // Задняя правая фара
        'el-11': this.$t('car_parts.bumper_rear'),              // Задний бампер
        'el-12': this.$t('car_parts.fender_front_left'),        // Левое переднее крыло
        'el-13': this.$t('car_parts.wheel_front_left'),         // Левое переднее колесо
        'el-14': this.$t('car_parts.door_front_left'),          // Левая передняя дверь
        'el-15': this.$t('car_parts.door_rear_left'),           // Задняя левая дверь
        'el-16': this.$t('car_parts.wheel_rear_left'),          // Левое заднее колесо
        'el-17': this.$t('car_parts.fender_rear_left'),         // Заднее левое крыло
        'el-18': this.$t('car_parts.fender_front_right'),       // Правое переднее крыло
        'el-19': this.$t('car_parts.wheel_front_right'),        // Правое переднее колесо
        'el-20': this.$t('car_parts.trunk'),                    // Багажник
        'el-21': this.$t('car_parts.door_rear_right'),          // Задняя правая дверь
        'el-22': this.$t('car_parts.wheel_rear_right'),         // Правое заднее колесо
        'el-23': this.$t('car_parts.fender_rear_right'),         // Заднее правое крыло
        'el-24': this.$t('car_parts.bumper_front'),              // Передний бампер
        'el-27': this.$t('car_parts.window_front_left'),        // Стекло левой передней двери
        'el-26': this.$t('car_parts.rear_glass'),               // Заднее стекло
        'el-8': this.$t('car_parts.window_rear_left'),         // Стекло левой задней двери
        'el-28': this.$t('car_parts.window_rear_right'),        // Стекло правой задней двери
        'el-29': this.$t('car_parts.turn_signal_right'),        // Правый поворотник
        'el-30': this.$t('car_parts.turn_signal_left'),      // Левый поворотник
        'el-31': this.$t('car_parts.door_handle_front_left'),           // Ручка передней левой двери
        'el-32': this.$t('car_parts.door_handle_front_right'),          // Ручка передней правой двери
        'el-33': this.$t('car_parts.door_front_right'),        // Передняя правая дверь
        'el-34': this.$t('car_parts.door_front_left'),        // Передняя левая дверь
        'el-35': this.$t('car_parts.window_front_right'),        // Стекло правой передней двери
        'el-36': this.$t('car_parts.window_rear_right'),        // Стекло правой задней двери
        'el-37': this.$t('car_parts.quarter_glass_right'),        // правая форточка задней двери
        'el-38': this.$t('car_parts.quarter_glass_left'),        // левая форточка задней двери
        'el-39': this.$t('car_parts.door_handle_rear_left'),        // Ручка задней левой двери
        'el-40': this.$t('car_parts.door_handle_rear_right'),        // Ручка задней правой двери
      };
    },
    
    // Динамические цвета для SVG в зависимости от темы
    svgColors() {
      const isDark = this.$vuetify.theme.dark;
      return {
        stroke: isDark ? '#e0e0e0' : '#000000',           // Обводка: светло-серая в темной теме, черная в светлой
        glass: isDark ? 'rgba(96, 125, 139, 0.3)' : '#f0ffeb', // Стекла: полупрозрачный синий в темной, светло-зеленый в светлой
        headlight: isDark ? '#FFC107' : '#ffffc0',        // Фары: более яркий желтый в темной теме
        wheel: isDark ? '#616161' : '#c8c8c8',            // Колеса: темно-серый в темной теме
        wheelCenter: isDark ? '#424242' : '#ffffff',      // Центр колеса
        indicator: isDark ? '#FF9800' : '#ffcb00',        // Поворотники: оранжевый в темной теме
        reflector: isDark ? '#9E9E9E' : '#e6e6e6',        // Отражатели
        detail: isDark ? '#757575' : '#3c3c3c',           // Детали
      };
    }
  },
  watch: {
    value: {
      handler(newVal) {
        console.log('=== value watch triggered ===');
        console.log('newVal:', newVal);
        console.log('newVal type:', typeof newVal);
        console.log('newVal isArray:', Array.isArray(newVal));
        console.log('newVal length:', newVal && Array.isArray(newVal) ? newVal.length : 'N/A');
        console.log('Current damages length:', this.damages.length);
        console.log('updatingFromInternal:', this.updatingFromInternal);
        
        // Не обновляем из prop, если это внутреннее обновление
        if (this.updatingFromInternal) {
          console.log('Skipping value watch - internal update in progress');
          return;
        }
        
        // Если prop пустой или undefined, НЕ трогаем локальный массив
        // Это позволяет работать независимо от prop
        if (!newVal || (Array.isArray(newVal) && newVal.length === 0)) {
          console.log('Prop value is empty, keeping local damages:', this.damages.length);
          // КРИТИЧНО: Если локально есть данные, НЕ сбрасываем их!
          if (this.damages.length > 0) {
            console.log('Local damages exist, NOT overwriting with empty prop!');
          }
          return;
        }
        
        // Обновляем только если prop содержит данные И они отличаются от локальных
        if (newVal && Array.isArray(newVal) && newVal.length > 0) {
          const newDamagesStr = JSON.stringify(newVal);
          const currentDamagesStr = JSON.stringify(this.damages);
          if (newDamagesStr !== currentDamagesStr) {
            console.log('Updating damages from prop (prop has data), newVal:', newVal);
            this.updatingFromInternal = true;
            // Нормализуем данные (преобразуем car_part в carPart)
            this.damages = this.normalizeDamages(JSON.parse(JSON.stringify(newVal)));
            if (this.damages.length > 0) {
              this.nextId = Math.max(...this.damages.map(d => d.id || 0)) + 1;
            }
            console.log('Damages updated from prop:', this.damages);
            this.$nextTick(() => {
              this.updatingFromInternal = false;
            });
          } else {
            console.log('Prop value same as local, skipping update');
          }
        }
      },
      immediate: true
    },
    damages: {
      handler(newVal) {
        console.log('damages watch triggered, length:', newVal ? newVal.length : 0);
        console.log('updatingFromInternal:', this.updatingFromInternal);
        
        // Предотвращаем рекурсию - используем флаг для отслеживания внутренних изменений
        if (this.updatingFromInternal) {
          console.log('Skipping emit - internal update in progress');
          return;
        }
        
        console.log('Emitting damages update to parent, length:', newVal.length);
        this.updatingFromInternal = true;
        
        // Эмитим копию массива, чтобы не было ссылок
        const damagesCopy = JSON.parse(JSON.stringify(newVal));
        this.$emit('input', damagesCopy);
        
        console.log('After emit, waiting for nextTick...');
        this.$nextTick(() => {
          console.log('Flag reset after emit, damages length:', this.damages.length);
          this.updatingFromInternal = false;
        });
      },
      deep: true,
      immediate: false
    }
  },
  created() {
    // Инициализируем damages из prop если он есть
    if (this.value && Array.isArray(this.value) && this.value.length > 0) {
      console.log('Initializing damages from prop in created():', this.value);
      // Нормализуем данные (преобразуем car_part в carPart)
      this.damages = this.normalizeDamages(JSON.parse(JSON.stringify(this.value)));
      if (this.damages.length > 0) {
        this.nextId = Math.max(...this.damages.map(d => d.id || 0)) + 1;
      }
    }
  },
  mounted() {
    this.calculateSvgHeight();
    console.log('CarDamageMarker mounted, damages:', this.damages);
    console.log('Damages array length:', this.damages.length);
    // Проверяем, что маркеры должны отображаться
    if (this.damages.length > 0) {
      console.log('Damages to render:', this.damages);
      this.damages.forEach((damage, index) => {
        console.log(`Damage ${index + 1}: x=${damage.x}, y=${damage.y}, id=${damage.id}`);
      });
    } else {
      console.log('No damages to render.');
    }
  },
  methods: {
    /**
     * Нормализует данные о повреждении: преобразует car_part в carPart
     */
    normalizeDamage(damage) {
      return {
        ...damage,
        carPart: damage.carPart || damage.car_part || null
      };
    },
    
    /**
     * Нормализует массив повреждений
     */
    normalizeDamages(damages) {
      if (!damages || !Array.isArray(damages)) return [];
      return damages.map(d => this.normalizeDamage(d));
    },
    
    handleSvgClick(event) {
      // Если режим только для чтения, не обрабатываем клик
      if (this.readonly) {
        return;
      }
      
      // Проверяем, не кликнули ли на существующий маркер
      if (event.target.closest('.damage-marker-group') || event.target.classList.contains('damage-point') || event.target.classList.contains('damage-number')) {
        return;
      }
      
      const svg = this.$refs.carSvg;
      if (!svg) {
        console.error('SVG ref not found');
        return;
      }
      
      try {
        // Получаем координаты клика относительно SVG
        const rect = svg.getBoundingClientRect();
        const point = svg.createSVGPoint();
        point.x = event.clientX;
        point.y = event.clientY;
        
        const ctm = svg.getScreenCTM();
        if (!ctm) {
          console.error('Cannot get SVG CTM');
          return;
        }
        
        const svgPoint = point.matrixTransform(ctm.inverse());
        
        // Проверяем, что координаты в пределах viewBox
        if (svgPoint.x < 0 || svgPoint.x > 1041 || svgPoint.y < 0 || svgPoint.y > 1617) {
          console.warn('Click outside viewBox:', svgPoint);
          return;
        }
        
        // Определяем, на какую часть кузова кликнули
        const carPart = this.detectCarPart(event.target);
        
        // Создаем новое повреждение - НЕ устанавливаем id, он будет создан при сохранении
        this.currentDamage = {
          id: null,  // Важно: null для нового повреждения!
          x: svgPoint.x,
          y: svgPoint.y,
          damage_type: 'scratch',
          description: '',
          carPart: carPart,
          photo: null
        };
        
        console.log('New damage created:', this.currentDamage, 'carPart:', carPart, "carPart name:", this.getCarPartName(carPart));
        console.log('currentDamage.id:', this.currentDamage.id);
        this.showDamageDialog = true;
      } catch (error) {
        console.error('Error handling SVG click:', error);
      }
    },
    
    detectCarPart(element) {
      // Определяем часть кузова по классу элемента
      let currentElement = element;
      let maxDepth = 10;
      let depth = 0;
      
      while (currentElement && depth < maxDepth) {
        if (currentElement.classList) {
          for (let className of currentElement.classList) {
            if (className.startsWith('el-')) {
              return className;
            }
          }
        }
        currentElement = currentElement.parentElement;
        depth++;
      }
      return null;
    },
    
    getCarPartName(carPart) {
      // Возвращает русское название части автомобиля
      if (!carPart) return this.$t('car_parts.unknown');
      return this.carPartNames[carPart] || this.$t('car_parts.unknown');
    },
    
    scrollToMarker(damage) {
      // Плавный скролл к маркеру на диаграмме
      if (!this.$refs.carSvg || !damage) {
        console.warn('scrollToMarker: SVG ref or damage not found');
        return;
      }
      
      try {
        const svgElement = this.$refs.carSvg;
        console.log('SVG element:', svgElement);
        
        // Сначала скроллим к самому SVG (на случай если он не виден)
        svgElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        // Затем через небольшую задержку скроллим к конкретному маркеру
        setTimeout(() => {
          // Получаем размеры SVG
          const svgRect = svgElement.getBoundingClientRect();
          console.log('SVG rect:', svgRect);
          
          // Вычисляем позицию маркера в пикселях
          // viewBox="0 0 1041 1617", используем соотношение
          const viewBoxWidth = 1041;
          const viewBoxHeight = 1617;
          const scaleX = svgRect.width / viewBoxWidth;
          const scaleY = svgRect.height / viewBoxHeight;
          
          const markerPixelY = damage.y * scaleY;
          console.log('Marker Y in pixels:', markerPixelY, 'from damage.y:', damage.y);
          
          // Находим scrollable родителя
          let scrollParent = svgElement.parentElement;
          while (scrollParent) {
            const overflow = window.getComputedStyle(scrollParent).overflow;
            const overflowY = window.getComputedStyle(scrollParent).overflowY;
            
            if (overflow === 'auto' || overflow === 'scroll' || overflowY === 'auto' || overflowY === 'scroll') {
              console.log('Found scrollable parent:', scrollParent);
              break;
            }
            scrollParent = scrollParent.parentElement;
            if (scrollParent === document.body) {
              scrollParent = window;
              break;
            }
          }
          
          // Вычисляем целевую позицию для центрирования маркера
          if (scrollParent === window) {
            const targetY = svgRect.top + window.scrollY + markerPixelY - (window.innerHeight / 2);
            window.scrollTo({
              top: Math.max(0, targetY),
              behavior: 'smooth'
            });
          } else if (scrollParent) {
            const parentRect = scrollParent.getBoundingClientRect();
            const targetScrollTop = svgRect.top - parentRect.top + scrollParent.scrollTop + markerPixelY - (parentRect.height / 2);
            scrollParent.scrollTo({
              top: Math.max(0, targetScrollTop),
              behavior: 'smooth'
            });
          }
          
          // Подсветка маркера
          this.highlightMarker(damage.id);
        }, 300);
        
      } catch (error) {
        console.error('Error scrolling to marker:', error);
      }
    },
    
    highlightMarker(damageId) {
      // Временно подсвечиваем маркер
      console.log('Highlighting marker:', damageId);
      this.highlightedDamageId = damageId;
      
      // Убираем подсветку через 3 секунды
      setTimeout(() => {
        if (this.highlightedDamageId === damageId) {
          this.highlightedDamageId = null;
        }
      }, 3000);
    },
    
    async saveDamage() {
      console.log('=== saveDamage START ===');
      console.log('this:', this);
      console.log('this.updatingFromInternal:', this.updatingFromInternal);
      console.log('this.damages:', this.damages);
      console.log('this.damages.length:', this.damages ? this.damages.length : 'damages is null/undefined');
      console.log('this.currentDamage:', this.currentDamage);
      console.log('this.currentDamage.id:', this.currentDamage.id);
      console.log('!this.currentDamage.id:', !this.currentDamage.id);
      
      try {
        console.log('Entering try block');
        if (!this.currentDamage.id) {
          console.log('Inside if (!this.currentDamage.id) - NEW damage');
          // Новое повреждение
          const newDamage = { 
            id: this.nextId++,
            x: parseFloat(this.currentDamage.x),
            y: parseFloat(this.currentDamage.y),
            damage_type: this.currentDamage.damage_type,
            description: this.currentDamage.description || '',
            carPart: this.currentDamage.carPart,
            photo: this.currentDamage.photo || null
          };
          
          console.log('New damage object:', newDamage);
          
          // Инициализируем массив, если его нет
          if (!this.damages || !Array.isArray(this.damages)) {
            console.log('Initializing damages array');
            this.$set(this, 'damages', []);
          }
          
          // Устанавливаем флаг
          this.$set(this, 'updatingFromInternal', true);
          console.log('Flag set, updatingFromInternal:', this.updatingFromInternal);
          
          // Создаем новый массив
          const currentDamages = Array.isArray(this.damages) ? this.damages : [];
          const newDamagesArray = [...currentDamages, newDamage];
          console.log('New array created, length:', newDamagesArray.length);
          
          // Присваиваем через $set для реактивности
          this.$set(this, 'damages', newDamagesArray);
          console.log('Array set via $set, length:', this.damages.length);
          
          // Эмитим родителю
          const damagesCopy = JSON.parse(JSON.stringify(this.damages));
          console.log('Emitting to parent, copy length:', damagesCopy.length);
          this.$emit('input', damagesCopy);
          console.log('Emitted to parent');
          
          // Сохраняем в базу данных и ЖДЕМ обновления ID
          await this.saveDamagesToServer();
          
          // После сохранения переключаемся в режим загрузки фото (НЕ закрываем диалог)
          this.$nextTick(() => {
            // Обновляем currentDamage с новым ID от сервера
            const savedDamage = this.damages.find(d => 
              Math.abs(d.x - this.currentDamage.x) < 0.01 && 
              Math.abs(d.y - this.currentDamage.y) < 0.01 &&
              d.damage_type === this.currentDamage.damage_type
            );
            if (savedDamage) {
              this.currentDamage.id = savedDamage.id;
              this.uploadingDamageId = savedDamage.id;
            }
            this.showPhotoUploadInDialog = true;
          });
          console.log('Switched to photo upload mode');
          
          // Проверяем через nextTick
          this.$nextTick(() => {
            console.log('=== nextTick callback ===');
            console.log('damages length:', this.damages.length);
            console.log('damages:', this.damages);
            
            if (this.damages.length === 0) {
              console.error('ERROR: Array is empty!');
            } else {
              console.log('SUCCESS! Array has', this.damages.length, 'items');
            }
            setTimeout(() => {
              this.$set(this, 'updatingFromInternal', false);
            }, 500);
          });
        } else {
          console.log('Inside else block - EDITING existing damage');
          // Обновление существующего
          const index = this.damages.findIndex(d => d.id === this.currentDamage.id);
          console.log('Found index:', index);
          if (index !== -1) {
            this.$set(this.damages, index, { 
              id: this.currentDamage.id,
              x: parseFloat(this.currentDamage.x),
              y: parseFloat(this.currentDamage.y),
              damage_type: this.currentDamage.damage_type,
              description: this.currentDamage.description || '',
              carPart: this.currentDamage.carPart,
              photo: this.currentDamage.photo || null
            });
            this.$emit('input', [...this.damages]);
            
            // Сохраняем в базу данных и ЖДЕМ обновления ID
            await this.saveDamagesToServer();
            
            // Если у повреждения нет фото, переключаемся в режим загрузки
            if (!this.currentDamage.photo) {
              this.uploadingDamageId = this.currentDamage.id;
              this.showPhotoUploadInDialog = true;
            } else {
              // Если фото уже есть, закрываем диалог
              this.cancelEdit();
            }
          } else {
            this.cancelEdit();
          }
        }
        console.log('Exiting try block');
      } catch (error) {
        console.error('=== ERROR in saveDamage ===');
        console.error('Error:', error);
        console.error('Message:', error.message);
        console.error('Stack:', error.stack);
      }
      
      console.log('=== saveDamage END ===');
    },
    
    editDamage(damage) {
      // Если режим только для чтения, не позволяем редактировать
      if (this.readonly) {
        return;
      }
      this.currentDamage = JSON.parse(JSON.stringify(damage));
      this.showDamageDialog = true;
    },
    
    cancelEdit() {
      this.showDamageDialog = false;
      this.showPhotoUploadInDialog = false;
      this.uploadingDamageId = null;
      this.currentDamage = {
        id: null,
        x: 0,
        y: 0,
        damage_type: 'scratch',
        description: '',
        carPart: null,
        photo: null
      };
    },
    
    skipPhotoUpload() {
      // Закрываем диалог без загрузки фото
      this.cancelEdit();
      this.$notify(this.$t('custom.success'), this.$t('bookings.damage_saved'), 'success', 3000);
    },
    
    /**
     * Обрабатывает успешную загрузку фото повреждения в диалоге
     */
    async handleDamagePhotoUploadSuccessInDialog(data) {
      console.log('=== Photo uploaded successfully in dialog ===');
      console.log('Upload data:', data);
      console.log('uploadingDamageId:', this.uploadingDamageId);
      
      try {
        // Обновляем повреждение с информацией о фото
        const damageIndex = this.damages.findIndex(d => d.id === this.uploadingDamageId);
        console.log('Found damage at index:', damageIndex);
        
        if (damageIndex !== -1) {
          // КРИТИЧНО: Устанавливаем флаг ПЕРЕД обновлением, чтобы избежать конфликтов с watcher
          this.updatingFromInternal = true;
          
          const photoData = {
            id: data.booking_photo_id,
            url: data.image_url,
            small_url: data.image_url
          };
          
          console.log('Setting photo data:', photoData);
          
          // Обновляем фото в повреждении
          this.$set(this.damages[damageIndex], 'photo', photoData);
          
          // Обновляем также в currentDamage
          this.$set(this.currentDamage, 'photo', photoData);
          
          console.log('Damage after photo update:', this.damages[damageIndex]);
          
          // Эмитим обновленные данные родителю (делаем глубокую копию)
          const damagesCopy = JSON.parse(JSON.stringify(this.damages));
          this.$emit('input', damagesCopy);
          
          console.log('Emitted damages to parent');
          
          // Ждем применения изменений
          await this.$nextTick();
          
          // Сбрасываем флаг
          this.updatingFromInternal = false;
          
          console.log('Photo update completed successfully');
        } else {
          console.error('Could not find damage with id:', this.uploadingDamageId);
        }
        
        this.$notify(this.$t('custom.success'), this.$t('bookings.photo_uploaded_successfully'), 'success', 3000);
        
        // Закрываем диалог после успешной загрузки
        this.cancelEdit();
      } catch (error) {
        console.error('Error updating damage with photo:', error);
        this.$notify(this.$t('errors.error'), this.$t('bookings.error_uploading_photo'), 'error', 5000);
      } finally {
        console.log('=== Photo upload handler finished ===');
      }
    },
    
    async removeDamage(id) {
      const index = this.damages.findIndex(d => d.id === id);
      if (index !== -1) {
        this.damages.splice(index, 1);
        this.$emit('input', [...this.damages]);
        
        // Сохраняем в базу данных и ЖДЕМ обновления ID
        await this.saveDamagesToServer();
      }
    },
    
    clearAllDamages() {
      this.$confirm({
        title: this.$t('custom.you_sure_title'),
        text: this.$t('bookings.clear_all_damages_confirm'),
        icon: "mdi-alert-circle-outline",
        confirmButtonText: this.$t('custom.yes'),
        cancelButtonText: this.$t('custom.no'),
      }).then(async (result) => {
        if (result) {
          this.damages = [];
          this.$emit('input', []);
          
          // Сохраняем в базу данных и ЖДЕМ обновления ID
          await this.saveDamagesToServer();
        }
      });
    },
    
    getDamageTypeColor(type) {
      const colors = {
        scratch: 'deep-orange darken-2',
        dent: 'red darken-1',
        crack: 'blue darken-3',
        break: 'green accent-4',
        other: 'grey darken-3'
      };
      return colors[type] || 'grey darken-3';
    },
    
    getDamageTypeColorHex(type) {
      const colors = {
        scratch: '#FF6B00',   // Ярко-оранжевый для царапин (хорошо виден на белом)
        dent: '#E53935',      // Насыщенный красный для вмятин
        crack: '#1565C0',     // Темно-синий для трещин (контрастный)
        break: '#00C853',     // Ярко-зеленый для разрывов/сколов
        other: '#212121'      // Почти черный для прочего
      };
      return colors[type] || '#212121';
    },
    
    getDamageTypeLabel(type) {
      const typeObj = this.damageTypes.find(t => t.value === type);
      return typeObj ? typeObj.text : type;
    },
    
    calculateSvgHeight() {
      // Вычисляем высоту SVG на основе ширины контейнера и соотношения сторон viewBox
      this.$nextTick(() => {
        if (this.$refs.carMapContainer) {
          const containerWidth = this.$refs.carMapContainer.clientWidth;
          if (containerWidth > 0) {
            // viewBox: 0 0 1041 1617, соотношение сторон: 1617/1041 ≈ 1.554
            const aspectRatio = 1617 / 1041;
            const calculatedHeight = containerWidth * aspectRatio;
            this.svgHeight = `${Math.min(calculatedHeight, 800)}px`;
          }
        }
      });
    },
    
    /**
     * Генерирует изображение SVG с маркерами повреждений для вставки в документ
     * @returns {Object|null} Объект с svg строкой и base64, или null если нет повреждений
     */
    generateDamageImage() {
      // Генерируем изображение диаграммы всегда, даже если повреждений нет
      // (чистая диаграмма подтверждает отсутствие повреждений)
      const svgElement = this.$refs.carSvg;
      if (!svgElement) {
        console.error('SVG element not found');
        return null;
      }
      
      try {
        // Клонируем SVG для модификации
        const svgClone = svgElement.cloneNode(true);
        
        // Удаляем интерактивные элементы и стили
        svgClone.querySelectorAll('[style*="cursor"]').forEach(el => {
          el.removeAttribute('style');
        });
        
        // Удаляем обработчики событий
        svgClone.removeAttribute('@click');
        svgClone.querySelectorAll('[class*="damage-marker-group"]').forEach(el => {
          el.removeAttribute('@click.stop');
        });
        
        // Устанавливаем фиксированный размер для экспорта
        svgClone.setAttribute('width', '1041');
        svgClone.setAttribute('height', '1617');
        svgClone.setAttribute('viewBox', '0 0 1041 1617');
        svgClone.removeAttribute('preserveAspectRatio');
        
        // Конвертируем SVG в строку
        const svgString = new XMLSerializer().serializeToString(svgClone);
        
        // Конвертируем в base64 для вставки в документ
        const base64 = btoa(unescape(encodeURIComponent(svgString)));
        
        return {
          svg: svgString,
          base64: `data:image/svg+xml;base64,${base64}`,
          dataUrl: `data:image/svg+xml;base64,${base64}`
        };
      } catch (error) {
        console.error('Error generating damage image:', error);
        return null;
      }
    },
    
    /**
     * Конвертирует SVG в PNG через canvas (если нужен растровый формат)
     * @param {String} svgString - SVG строка
     * @param {Number} width - Ширина изображения
     * @param {Number} height - Высота изображения
     * @returns {Promise<Object>} Promise с объектом содержащим blob, base64 и dataUrl
     */
    async convertSvgToPng(svgString, width = 1041, height = 1617) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        canvas.width = width;
        canvas.height = height;
        
        img.onload = () => {
          ctx.drawImage(img, 0, 0);
          canvas.toBlob((blob) => {
            if (!blob) {
              reject(new Error('Failed to create blob'));
              return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
              resolve({
                blob: blob,
                base64: reader.result,
                dataUrl: canvas.toDataURL('image/png')
              });
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          }, 'image/png');
        };
        
        img.onerror = reject;
        img.src = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svgString)))}`;
      });
    },
    
    /**
     * Загружает изображение повреждений на S3 через Uppy
     * @returns {Promise<Object>} Promise с результатом загрузки
     */
    async uploadDamageImageToS3() {
      console.log('[uploadDamageImageToS3] Starting upload process');
      console.log('[uploadDamageImageToS3] damages:', this.damages);
      console.log('[uploadDamageImageToS3] bookingId:', this.bookingId);
      
      // Изображение загружаем всегда, даже если повреждений нет (для подтверждения отсутствия повреждений)
      if (!this.bookingId) {
        console.error('[uploadDamageImageToS3] Booking ID is required for upload');
        return { success: false, error: 'No booking ID' };
      }
      
      try {
        this.isUploading = true;
        console.log('[uploadDamageImageToS3] Generating damage image...');
        
        // Генерируем SVG изображение
        const imageData = this.generateDamageImage();
        if (!imageData) {
          console.error('[uploadDamageImageToS3] Failed to generate damage image');
          this.isUploading = false;
          return { success: false, error: 'Failed to generate image' };
        }
        console.log('[uploadDamageImageToS3] Image data generated successfully');
        
        // Конвертируем SVG в PNG
        console.log('[uploadDamageImageToS3] Converting SVG to PNG...');
        const pngData = await this.convertSvgToPng(imageData.svg);
        console.log('[uploadDamageImageToS3] PNG conversion completed, blob size:', pngData.blob.size);
        
        // Получаем presigned URL от бэкенда (используем специальный контроллер для изображений повреждений)
        console.log('[uploadDamageImageToS3] Requesting presigned URL...');
        const filename = `damage_${this.mode}_${this.bookingId}_${Date.now()}.png`;
        const presignedResponse = await this.axios.post(
          `api/v1/booking_damage_images/${this.bookingId}/presigned_url`,
          {
            filename: filename,
            content_type: 'image/png',
            mode: this.mode
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        );
        
        if (!presignedResponse.data || !presignedResponse.data.presigned_url) {
          console.error('[uploadDamageImageToS3] Failed to get presigned URL');
          this.isUploading = false;
          return { success: false, error: 'Failed to get presigned URL' };
        }
        
        console.log('[uploadDamageImageToS3] Presigned URL received:', presignedResponse.data);
        
        // Загружаем изображение на S3 через presigned POST (с полями)
        console.log('[uploadDamageImageToS3] Uploading to S3...');
        const formData = new FormData();
        
        // Добавляем поля из presigned_post
        if (presignedResponse.data.fields) {
          Object.keys(presignedResponse.data.fields).forEach(key => {
            formData.append(key, presignedResponse.data.fields[key]);
          });
        }
        
        // Добавляем файл
        formData.append('file', pngData.blob, filename);
        
        await this.axios.post(presignedResponse.data.presigned_url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        console.log('[uploadDamageImageToS3] Upload to S3 completed');
        
        // Формируем полный URL изображения на S3
        const imageUrl = `https://storage.yandexcloud.net/${presignedResponse.data.bucket}/${presignedResponse.data.key}`;
        console.log('[uploadDamageImageToS3] Image URL:', imageUrl);
        
        // Подтверждаем загрузку на бэкенде
        console.log('[uploadDamageImageToS3] Confirming upload...');
        const confirmResponse = await this.axios.post(
          `api/v1/booking_damage_images/${this.bookingId}/confirm_upload`,
          {
            mode: this.mode,
            image_url: imageUrl
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        );
        
        console.log('[uploadDamageImageToS3] Upload confirmed successfully');
        
        this.isUploading = false;
        return {
          success: true,
          image_url: imageUrl
        };
      } catch (error) {
        console.error('[uploadDamageImageToS3] Error uploading damage image:', error);
        this.isUploading = false;
        return {
          success: false,
          error: error.message || error
        };
      }
    },
    
    handleUploadSuccess(data) {
      console.log('Damage image uploaded successfully:', data);
      this.isUploading = false;
      this.uploadFile = null;
      
      if (this._uploadResolve) {
        this._uploadResolve({
          success: true,
          image_url: data.image_url
        });
        this._uploadResolve = null;
        this._uploadReject = null;
      }
    },
    
    handleUploadError(error) {
      console.error('Error uploading damage image:', error);
      this.isUploading = false;
      this.uploadFile = null;
      
      if (this._uploadReject) {
        this._uploadReject({
          success: false,
          error: error.message || error
        });
        this._uploadResolve = null;
        this._uploadReject = null;
      }
    },
    
    /**
     * Начинает процесс загрузки фото повреждения через Uppy
     */
    async startPhotoUpload(damage) {
      console.log('=== startPhotoUpload ===');
      console.log('damage:', damage);
      console.log('bookingId:', this.bookingId);
      console.log('mode:', this.mode);
      
      if (!this.bookingId) {
        console.error('Cannot upload photo: bookingId is not provided');
        this.$notify(this.$t('errors.error'), 'Booking ID not found', 'error', 5000);
        return;
      }
      
      this.uploadingDamageId = damage.id;
      
      // Ждем следующего тика, чтобы убедиться, что все данные обновлены
      await this.$nextTick();
      
      console.log('Opening dialog with uploadingDamageId:', this.uploadingDamageId);
      this.showPhotoUploadDialog = true;
    },
    
    /**
     * Отменяет загрузку фото
     */
    cancelPhotoUpload() {
      this.showPhotoUploadDialog = false;
      this.uploadingDamageId = null;
    },
    
    /**
     * Обрабатывает успешную загрузку фото повреждения через Uppy
     */
    async handleDamagePhotoUploadSuccess(data) {
      console.log('=== Photo uploaded successfully ===');
      console.log('Upload data:', data);
      console.log('uploadingDamageId:', this.uploadingDamageId);
      
      try {
        // Обновляем повреждение с информацией о фото
        const damageIndex = this.damages.findIndex(d => d.id === this.uploadingDamageId);
        console.log('Found damage at index:', damageIndex);
        
        if (damageIndex !== -1) {
          // КРИТИЧНО: Устанавливаем флаг ПЕРЕД обновлением, чтобы избежать конфликтов с watcher
          this.updatingFromInternal = true;
          
          const photoData = {
            id: data.booking_photo_id,
            url: data.image_url,
            small_url: data.image_url
          };
          
          console.log('Setting photo data:', photoData);
          
          // Обновляем фото в повреждении
          this.$set(this.damages[damageIndex], 'photo', photoData);
          
          console.log('Damage after photo update:', this.damages[damageIndex]);
          
          // Эмитим обновленные данные родителю (делаем глубокую копию)
          const damagesCopy = JSON.parse(JSON.stringify(this.damages));
          this.$emit('input', damagesCopy);
          
          console.log('Emitted damages to parent');
          
          // Ждем применения изменений
          await this.$nextTick();
          
          // Сбрасываем флаг
          this.updatingFromInternal = false;
          
          console.log('Photo update completed successfully');
        } else {
          console.error('Could not find damage with id:', this.uploadingDamageId);
        }
        
        this.$notify(this.$t('custom.success'), this.$t('bookings.photo_uploaded_successfully'), 'success', 5000);
        
        // Закрываем диалог после успешной загрузки
        this.showPhotoUploadDialog = false;
      } catch (error) {
        console.error('Error updating damage with photo:', error);
        this.$notify(this.$t('errors.error'), this.$t('bookings.error_uploading_photo'), 'error', 5000);
      } finally {
        // Сбрасываем ID загружаемого повреждения в самом конце
        this.uploadingDamageId = null;
        console.log('=== Photo upload handler finished ===');
      }
    },
    
    /**
     * Обрабатывает ошибку загрузки фото повреждения через Uppy
     */
    handleDamagePhotoUploadError(error) {
      console.error('Error uploading photo:', error);
      this.$notify(this.$t('errors.error'), this.$t('bookings.error_uploading_photo'), 'error', 5000);
      // FT-152: диалог и uploadingDamageId НЕ сбрасываем.
      //
      // Кнопка повтора живёт внутри самого загрузчика, а он смонтирован ровно по этим
      // двум условиям (v-if в обоих местах использования). Сбрасывая их на ошибке, мы
      // уничтожали единственную возможность переслать фотографию — и именно в тот
      // момент, когда она нужна. Оба диалога модальные и закрываются явной кнопкой
      // (cancelPhotoUpload / cancelEdit), там же состояние и сбрасывается.
    },
    
    /**
     * Сохраняет повреждения на сервер
     */
    async saveDamagesToServer() {
      console.log('[saveDamagesToServer] Called');
      
      if (!this.bookingId) {
        console.warn('[saveDamagesToServer] Cannot save damages: bookingId is not provided');
        return;
      }
      
      // Если идет загрузка фото, не сохраняем (чтобы не перезаписать только что загруженное фото)
      if (this.uploadingDamageId) {
        console.log('[saveDamagesToServer] Skipping save - photo upload in progress for damage:', this.uploadingDamageId);
        return;
      }
      
      try {
        // Формируем данные для отправки
        const damagesPayload = this.damages.map(damage => ({
          x: damage.x,
          y: damage.y,
          damage_type: damage.damage_type,
          description: damage.description || '',
          car_part: damage.carPart || null
        }));
        
        const params = {};
        if (this.mode === 'checkin') {
          params.checkin_damages = damagesPayload;
        } else {
          params.checkout_damages = damagesPayload;
        }
        
        console.log('Saving damages to server:', params);
        
        // Отправляем на специальный эндпоинт для повреждений
        const response = await this.axios.patch(
          `/api/v1/bookings/${this.bookingId}/damages`,
          params,
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        );
        
        console.log('Damages saved successfully, response:', response.data);
        
        // КРИТИЧНО: Обновляем локальные ID с теми, что вернул сервер
        if (response.data) {
          const serverDamages = this.mode === 'checkin' 
            ? response.data.checkin_damages 
            : response.data.checkout_damages;
          
          if (serverDamages && Array.isArray(serverDamages)) {
            console.log('Updating local damages with server IDs:', serverDamages);
            
            // Если есть активная загрузка фото, запоминаем координаты повреждения
            let uploadingDamageCoords = null;
            if (this.uploadingDamageId) {
              const uploadingDamage = this.damages.find(d => d.id === this.uploadingDamageId);
              if (uploadingDamage) {
                uploadingDamageCoords = {
                  x: uploadingDamage.x,
                  y: uploadingDamage.y,
                  damage_type: uploadingDamage.damage_type
                };
                console.log('Found uploading damage coords:', uploadingDamageCoords);
              }
            }
            
            // Устанавливаем флаг, чтобы избежать циклических обновлений
            this.updatingFromInternal = true;
            
            // КРИТИЧНО: Сохраняем старый массив повреждений ДО обновления
            const oldDamages = [...this.damages];
            
            // Сохраняем информацию о ВСЕХ фото перед обновлением
            // КРИТИЧНО: Сопоставляем по координатам и типу, а не по индексу!
            const photosToUpdate = [];
            oldDamages.forEach((oldDamage) => {
              if (oldDamage.photo && oldDamage.photo.id) {
                // Ищем соответствующее повреждение на сервере по координатам и типу
                const matchingServerDamage = serverDamages.find(sd => 
                  Math.abs(sd.x - oldDamage.x) < 0.01 && 
                  Math.abs(sd.y - oldDamage.y) < 0.01 && 
                  sd.damage_type === oldDamage.damage_type
                );
                
                if (matchingServerDamage) {
                  photosToUpdate.push({
                    oldDamageId: oldDamage.id,
                    newDamageId: matchingServerDamage.id,
                    photoId: oldDamage.photo.id,
                    photo: oldDamage.photo,
                    coords: `(${oldDamage.x}, ${oldDamage.y})`
                  });
                } else {
                  console.warn(`No matching server damage found for damage ${oldDamage.id} at (${oldDamage.x}, ${oldDamage.y})`);
                }
              }
            });
            
            console.log('Photos to update:', photosToUpdate);
            console.log('Old damages count:', oldDamages.length);
            console.log('Server damages count:', serverDamages.length);
            
            // Обновляем damages с новыми ID от сервера, сохраняя фото если оно было
            // КРИТИЧНО: Сопоставляем по координатам, а не по индексу!
            this.damages = serverDamages.map((serverDamage) => {
              // Ищем соответствующее старое повреждение по координатам и типу
              const matchingOldDamage = oldDamages.find(od => 
                Math.abs(od.x - serverDamage.x) < 0.01 && 
                Math.abs(od.y - serverDamage.y) < 0.01 && 
                od.damage_type === serverDamage.damage_type
              );
              
              // Определяем, какое фото использовать (приоритет локальному)
              let photoToUse = null;
              if (matchingOldDamage && matchingOldDamage.photo) {
                // Используем локальное фото (может быть только что загружено)
                photoToUse = matchingOldDamage.photo;
                console.log(`✓ Preserving LOCAL photo for damage at (${serverDamage.x}, ${serverDamage.y}): old ID ${matchingOldDamage.id} -> new ID ${serverDamage.id}, photo ID: ${matchingOldDamage.photo.id}`);
              } else if (serverDamage.photo) {
                // Используем фото от сервера
                photoToUse = serverDamage.photo;
                console.log(`✓ Using SERVER photo for damage at (${serverDamage.x}, ${serverDamage.y}): ID ${serverDamage.id}`);
              }
              
              return {
                id: serverDamage.id,
                x: serverDamage.x,
                y: serverDamage.y,
                damage_type: serverDamage.damage_type,
                description: serverDamage.description,
                carPart: serverDamage.car_part, // Преобразуем snake_case в camelCase
                // КРИТИЧНО: Приоритет локальному фото над серверным
                photo: photoToUse
              };
            });
            
            // Обновляем uploadingDamageId с новым ID, если загрузка была активна
            if (uploadingDamageCoords) {
              const newUploadingDamage = this.damages.find(d => 
                Math.abs(d.x - uploadingDamageCoords.x) < 0.01 && 
                Math.abs(d.y - uploadingDamageCoords.y) < 0.01 && 
                d.damage_type === uploadingDamageCoords.damage_type
              );
              if (newUploadingDamage) {
                console.log('Updating uploadingDamageId from', this.uploadingDamageId, 'to', newUploadingDamage.id);
                this.uploadingDamageId = newUploadingDamage.id;
              } else {
                console.warn('Could not find new uploading damage by coords');
                this.uploadingDamageId = null;
              }
            }
            
            // КРИТИЧНО: Обновляем booking_damage_id у фото на сервере
            if (photosToUpdate.length > 0) {
              console.log('Updating photo damage IDs on server...');
              let updatedCount = 0;
              let notFoundCount = 0;
              let errorCount = 0;
              
              for (const photoUpdate of photosToUpdate) {
                // Обновляем только если ID реально изменился
                if (photoUpdate.oldDamageId !== photoUpdate.newDamageId) {
                  try {
                    await this.axios.patch(
                      `/api/v1/booking_photos/${photoUpdate.photoId}`,
                      { booking_damage_id: photoUpdate.newDamageId },
                      {
                        headers: {
                          Authorization: this.$store.getters.getAuthToken
                        }
                      }
                    );
                    console.log(`✓ Updated photo ${photoUpdate.photoId}: damage ${photoUpdate.oldDamageId} -> ${photoUpdate.newDamageId}`);
                    updatedCount++;
                  } catch (error) {
                    // 404 означает, что фото уже удалено - это нормально
                    if (error.response && error.response?.status === 404) {
                      console.log(`⚠ Photo ${photoUpdate.photoId} not found (already deleted), skipping`);
                      notFoundCount++;
                    } else {
                      console.error(`✗ Error updating photo ${photoUpdate.photoId}:`, error);
                      errorCount++;
                    }
                  }
                } else {
                  console.log(`⊘ Photo ${photoUpdate.photoId} already has correct damage_id ${photoUpdate.newDamageId}, skipping`);
                }
              }
              
              console.log(`Photo update summary: ${updatedCount} updated, ${notFoundCount} not found, ${errorCount} errors`);
            }
            
            console.log('Local damages updated with new IDs:', this.damages);
            
            // Эмитим обновленные данные родителю
            this.$emit('input', this.damages);
            
            // Сбрасываем флаг
            this.$nextTick(() => {
              this.updatingFromInternal = false;
            });
          }
        }
      } catch (error) {
        console.error('Error saving damages to server:', error);
        this.$notify(this.$t('errors.error'), this.$t('bookings.error_saving_damages'), 'error', 5000);
      }
    },
    
    /**
     * Открывает изображение в полноэкранном режиме
     */
    openFullscreenImage(imageUrl) {
      this.fullscreenImageUrl = imageUrl;
      this.showFullscreenImage = true;
    },
    
    /**
     * Удаляет фото повреждения
     */
    async deletePhoto(damage) {
      if (!damage.photo || !damage.photo.id) {
        return;
      }
      
      try {
        this.deletingPhotoId = damage.photo.id;
        
        // Удаляем фото на сервере
        await this.axios.delete(
          `/api/v1/booking_photos/${damage.photo.id}`,
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        );
        
        // Удаляем фото из локального объекта повреждения
        const damageIndex = this.damages.findIndex(d => d.id === damage.id);
        if (damageIndex !== -1) {
          this.$set(this.damages[damageIndex], 'photo', null);
          
          // Если это текущее редактируемое повреждение
          if (this.currentDamage.id === damage.id) {
            this.$set(this.currentDamage, 'photo', null);
          }
          
          this.$emit('input', this.damages);
        }
        
        this.$notify(this.$t('custom.success'), this.$t('bookings.photo_deleted_successfully'), 'success', 5000);
      } catch (error) {
        console.error('Error deleting photo:', error);
        this.$notify(this.$t('errors.error'), this.$t('bookings.error_deleting_photo'), 'error', 5000);
      } finally {
        this.deletingPhotoId = null;
      }
    }
  }
}
</script>

<style scoped>
.car-damage-marker {
  width: 100%;
}

.car-map-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity, 0.12));
  border-radius: 4px;
  overflow: auto;
  background: var(--v-background-lighten1);
  max-height: 800px;
  min-height: 400px;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

/* Адаптация рамки под темную тему */
.theme--dark .car-map-container {
  border-color: rgba(255, 255, 255, 0.12);
}

.car-map-container svg {
  display: block;
  cursor: crosshair;
  background: var(--v-background-base);
  transition: background-color 0.3s ease, stroke 0.3s ease, fill 0.3s ease;
}

/* Плавные переходы цветов для SVG элементов */
svg .car-outline * {
  transition: stroke 0.3s ease, fill 0.3s ease;
}

.car-damage-marker.readonly .car-map-container svg {
  cursor: default;
}

.damage-point {
  cursor: pointer;
  transition: r 0.2s;
  filter: drop-shadow(0 0 2px rgba(0,0,0,0.5));
}

.damage-point-highlighted {
  filter: drop-shadow(0 0 8px rgba(0,0,0,0.8)) drop-shadow(0 0 15px currentColor);
  animation: pulse-marker 1s ease-in-out infinite;
}

.damage-highlight {
  animation: pulse-ring 1.5s ease-out infinite;
  opacity: 0.8;
}

@keyframes pulse-ring {
  0% {
    r: 15;
    opacity: 0.8;
  }
  50% {
    r: 30;
    opacity: 0.4;
  }
  100% {
    r: 35;
    opacity: 0;
  }
}

@keyframes pulse-marker {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

.damage-marker-group:hover .damage-point {
  r: 15;
}

.damage-marker-group:hover .damage-number {
  font-size: 18;
}

.car-outline [class^="el-"] {
  pointer-events: all;
  cursor: pointer;
}

.car-outline [class^="el-"]:hover {
  opacity: 0.7;
}

.damage-list-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.previous-damage-item {
  background-color: rgba(158, 158, 158, 0.08);
  border-left: 3px solid rgba(158, 158, 158, 0.5);
}

.previous-damage-item:hover {
  background-color: rgba(158, 158, 158, 0.12);
}

.clickable-avatar {
  cursor: pointer;
  transition: transform 0.2s;
}

.clickable-avatar:hover {
  transform: scale(1.05);
}

.clickable-image {
  cursor: pointer;
  transition: opacity 0.2s;
}

.clickable-image:hover {
  opacity: 0.9;
}

.fullscreen-image-dialog {
  background-color: black !important;
}

.fullscreen-image-dialog .v-card__text {
  background-color: black;
  cursor: pointer;
}

.delete-photo-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(255, 255, 255, 0.9) !important;
  z-index: 1;
}

.delete-photo-btn:hover {
  background-color: rgba(255, 255, 255, 1) !important;
}

/* Адаптация SVG под темную/светлую тему */
svg .car-outline [stroke="#000"],
svg .car-outline [stroke="#000000"] {
  stroke: var(--svg-stroke) !important;
}

/* Стекла */
svg .car-outline .el-6 path[fill="#f0ffeb"],
svg .car-outline .el-8 path[fill="#f0ffeb"],
svg .car-outline path[fill="#f0ffeb"] {
  fill: var(--svg-glass) !important;
}

/* Фары */
svg .car-outline .el-3[fill="#ffffc0"],
svg .car-outline .el-4[fill="#ffffc0"],
svg .car-outline path[fill="#ffffc0"] {
  fill: var(--svg-headlight) !important;
}

/* Колеса */
svg .car-outline path[fill="#c8c8c8"],
svg .car-outline circle[fill="#c8c8c8"] {
  fill: var(--svg-wheel) !important;
}

svg .car-outline path[fill="#fff"],
svg .car-outline path[fill="#ffffff"],
svg .car-outline circle[fill="#fff"],
svg .car-outline circle[fill="#ffffff"] {
  fill: var(--svg-wheel-center) !important;
}

/* Поворотники */
svg .car-outline path[fill="#ffcb00"],
svg .car-outline circle[fill="#ffcb00"] {
  fill: var(--svg-indicator) !important;
}

/* Отражатели */
svg .car-outline path[fill="#e6e6e6"],
svg .car-outline circle[fill="#e6e6e6"] {
  fill: var(--svg-reflector) !important;
}

/* Детали */
svg .car-outline path[fill="#3c3c3c"],
svg .car-outline circle[fill="#3c3c3c"] {
  fill: var(--svg-detail) !important;
}
</style>
